import { TextBlock } from "@/lib/interfaces/blocks";
import { addNoopenerToBlankLinks } from "@/lib/helpers/html";
import { sanitiseHtml } from "@/lib/helpers/sanitise";
import SectionTitle from "@/components/SectionTitle";
import SectionContent from "@/components/SectionContent";
import BulbIcon from "@/components/icons/BulbIcon";
import BettingGuidesIcon from "@/components/icons/BettingGuidesIcon";
import CasinoChipIcon from "@/components/icons/CasinoChipIcon";
import OfferIcon from "@/components/icons/OfferIcon";
import PlayingCardsIcon from "@/components/icons/PlayingCardsIcon";
import PromoCodeIcon from "@/components/icons/PromoCodeIcon";

type TextType = {
  block: TextBlock;
};

export default function Text({ block }: TextType) {
  const shouldShowTitle =
    block.position !== 1 || !/\b\w+\s+(vs|VS)\s+\w+\b/i.test(block.content.title);

  let iconComponent;

  switch (block.content.icon) {
    case 'bulb':
      iconComponent = <BulbIcon />;
      break;
    case 'betting_guides':
      iconComponent = <BettingGuidesIcon />;
      break;
    case 'casino_chip':
      iconComponent = <CasinoChipIcon />;
      break;
    case 'offer':
      iconComponent = <OfferIcon />;
      break;
    case 'playing_cards':
      iconComponent = <PlayingCardsIcon />;
      break;
    case 'promo_code':
      iconComponent = <PromoCodeIcon />;
      break;
    default:
      iconComponent = null;
      break;
  }

  return (
    <section className="eo-section">
      {shouldShowTitle && block.content.title && block.content.title.length > 0 && (
        <SectionTitle title={block.content.title}>
          <div className="icon m-icon">
            {iconComponent}
          </div>
        </SectionTitle>
      )}
      <SectionContent>
        <div dangerouslySetInnerHTML={{ __html: sanitiseHtml(addNoopenerToBlankLinks(block.content.text)) }}></div>
      </SectionContent>
    </section>
  );
}